import { render, staticRenderFns } from "./dianping.vue?vue&type=template&id=550ef734&scoped=true&"
import script from "./dianping.vue?vue&type=script&lang=js&"
export * from "./dianping.vue?vue&type=script&lang=js&"
import style0 from "./dianping.vue?vue&type=style&index=0&id=550ef734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ef734",
  null
  
)

export default component.exports